import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Card, Typography } from '@mui/material'
import AddModeratorOutlinedIcon from '@mui/icons-material/AddModeratorOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import axios from 'axios'
import { api } from '../../utils/api'
import { getFromStorage } from '../../utils/storage'
import { handleError } from '../../utils/error'
import { useNavigate } from 'react-router-dom'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen, mainRed } from '../../utils/color'

export default function Authorization() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [roles, setRoles] = useState([])
	const getRoles = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_ROLES_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRoles(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, dispatch],
	)

	useEffect(() => {
		getRoles()
	}, [getRoles])

	const deleteRole = async (roleId) => {
		try {
			const response = await axios({
				url: api.DELETE_ROLE_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'DELETE',
				data: {
					roleId,
				},
				withCredentials: true,
			})
			alert(response.data.message)
			await getRoles()
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<UserLayout>
			<Box
				sx={{
					marginTop: '20px',
					maxWidth: 992,
					marginLeft: 'auto',
					marginRight: 'auto',
				}}>
				<Button
					size='medium'
					sx={{
						marginLeft: '20px',
						background: mainGreen,
						'&:hover': { background: mainGreen },
					}}
					variant='contained'
					onClick={() => {
						navigate('/admin/create-authorization')
					}}>
					<AddModeratorOutlinedIcon /> Tạo phân quyền mới
				</Button>
				<Box sx={{ mt: 3, mb: 2 }}>
					{roles?.map((role, index) => {
						return (
							<Card sx={{ mb: 1 }} key={index}>
								<Box sx={{ padding: '8px' }}>
									<Typography sx={{ mb: 1 }}>
										<b>{role.name}</b> - <i>{role.description}</i>
									</Typography>
									{role.permissionVN.map((item, index) => {
										return (
											<Typography component={'span'} key={index}>
												{item} <span style={{ fontWeight: 'bold' }}>/</span>{' '}
											</Typography>
										)
									})}
								</Box>
								<Box
									sx={{
										display: 'flex',
										justifyContent: 'space-between',
										padding: '8px',
									}}>
									<Button
										sx={{
											fontSize: '12px',
											color: mainGreen,
											borderColor: mainGreen,
											'&:hover': {
												borderColor: mainGreen,
											},
										}}
										size='small'
										variant='outlined'
										onClick={() => {
											navigate(`/admin/edit-authorization/${role._id}`)
										}}>
										Cập nhật quyền hạn
									</Button>
									<DeleteIcon
										sx={{ color: mainRed }}
										onClick={() => {
											const confirmDel = window.confirm('Xóa phân quyền này?')
											if (confirmDel) {
												deleteRole(role._id)
											}
										}}
									/>
								</Box>
							</Card>
						)
					})}
				</Box>
			</Box>
		</UserLayout>
	)
}
